module.exports = __webpack_public_path__ + "static/media/SocialMediaMarketing.d1b4eaec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/TrulyMadly/SocialMediaMarketing.jpg
// module id = 369
// module chunks = 0